import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { SPONSOR_STATION_DIVIDED_VALUE } from "../keys";

const useSponsorStationDividedValue = (sponsorObjectId) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  return useQuery({
    queryKey: [
      SPONSOR_STATION_DIVIDED_VALUE,
      sponsorObjectId,
      tenant.id,
      startDate,
      endDate,
    ],
    queryFn: () =>
      ApiService.getSponsorValuePerStation(sponsorObjectId, since, until),
    select: (data) => data.data.sources,
    placeholderData: { data: { sources: [] } },
  });
};
export default useSponsorStationDividedValue;
